"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import { Col, Container, Row } from "react-bootstrap";
import styles from "./Delegation.module.scss";
import { useSeizeConnectContext } from "@/components/auth/SeizeConnectContext";
import { DELEGATION_ALL_ADDRESS, GRADIENT_CONTRACT, MEMELAB_CONTRACT, MEMES_CONTRACT } from "@/constants/constants";
import { areEqualAddresses } from "@/helpers/Helpers";
import { DelegationCenterSection } from "@/types/enums";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useEffectEvent, useState } from "react";
import { SUPPORTED_COLLECTIONS } from "./delegation-constants";
interface Props {
  setSection(section: DelegationCenterSection): any;
}
export default function DelegationCenterComponent(props) {
  const $ = _c(34);
  const [redirect, setRedirect] = useState();
  const {
    isConnected,
    seizeConnect,
    seizeConnectOpen
  } = useSeizeConnectContext();
  const [openConnect, setOpenConnect] = useState(false);
  const {
    setSection
  } = props;
  let t0;
  if ($[0] !== isConnected || $[1] !== seizeConnect || $[2] !== setSection) {
    t0 = target => {
      if (!isConnected) {
        setOpenConnect(true);
        seizeConnect();
        return;
      }
      setSection(target);
    };
    $[0] = isConnected;
    $[1] = seizeConnect;
    $[2] = setSection;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const handleRedirect = useEffectEvent(t0);
  let t1;
  if ($[4] !== isConnected || $[5] !== openConnect || $[6] !== redirect || $[7] !== setSection) {
    t1 = () => {
      if (openConnect && redirect && isConnected) {
        setSection(redirect);
      }
      setRedirect(undefined);
    };
    $[4] = isConnected;
    $[5] = openConnect;
    $[6] = redirect;
    $[7] = setSection;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  const handleSeizeConnectClosed = useEffectEvent(t1);
  let t2;
  if ($[9] !== handleRedirect || $[10] !== redirect) {
    t2 = () => {
      if (!redirect) {
        return;
      }
      handleRedirect(redirect);
    };
    $[9] = handleRedirect;
    $[10] = redirect;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  let t3;
  if ($[12] !== redirect) {
    t3 = [redirect];
    $[12] = redirect;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  useEffect(t2, t3);
  let t4;
  if ($[14] !== handleSeizeConnectClosed || $[15] !== seizeConnectOpen) {
    t4 = () => {
      if (!seizeConnectOpen) {
        handleSeizeConnectClosed();
      }
    };
    $[14] = handleSeizeConnectClosed;
    $[15] = seizeConnectOpen;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  let t5;
  if ($[17] !== seizeConnectOpen) {
    t5 = [seizeConnectOpen];
    $[17] = seizeConnectOpen;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  useEffect(t4, t5);
  let t6;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = function printCollectionSelection() {
      return <Container className="no-padding"><Row className="pt-4 pb-2"><Col><h4>Manage by Collection</h4></Col></Row><Row>{Object.values(SUPPORTED_COLLECTIONS).map(c => <Col key={c.contract} xs={12} sm={6} md={3} className="pt-2 pb-2 d-flex flex-wrap gap-3"><button key={c.contract} className={styles.collectionSelectionButton} onClick={() => {
              const newSection = areEqualAddresses(c.contract, DELEGATION_ALL_ADDRESS) ? DelegationCenterSection.ANY_COLLECTION : areEqualAddresses(c.contract, MEMES_CONTRACT) ? DelegationCenterSection.MEMES_COLLECTION : areEqualAddresses(c.contract, MEMELAB_CONTRACT) ? DelegationCenterSection.MEME_LAB_COLLECTION : areEqualAddresses(c.contract, GRADIENT_CONTRACT) ? DelegationCenterSection.GRADIENTS_COLLECTION : null;
              if (newSection) {
                setRedirect(newSection);
              }
            }}><span className="d-flex align-items-center gap-3"><Image unoptimized={true} className={styles.collectionSelectionImage} loading="eager" priority={true} width={0} height={0} src={c.preview} alt={c.display} /><span>{c.title}</span></span></button></Col>)}</Row></Container>;
    };
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  const printCollectionSelection = t6;
  let t7;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Row className="pb-2"><Col><h1>Delegation Center</h1></Col></Row>;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <h3 className="pb-4">Delegations</h3>;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Image unoptimized={true} loading="eager" priority={true} src="/delegation-icon.png" alt="delegation" width={50} height={50} />;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Col sm={12} md={9} className="pt-2 pb-2 d-flex align-items-center justify-content-between gap-2"><span className="d-flex flex-column">{t8}<span className="d-flex align-items-center gap-3">{t9}<ul className="mb-0"><li>Mint with your hot wallet on behalf of your vault wallet</li><li>Eliminate manual wallet mapping</li></ul></span></span></Col>;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Row><Col><Container className={`${styles.delegationCenterSection} pt-4 pb-4`}><Row>{t10}<Col sm={12} md={3} className="pt-2 pb-2 d-flex flex-column gap-2 align-items-center justify-content-center"><button className={`${styles.addNewDelegationBtn}`} onClick={() => setRedirect(DelegationCenterSection.REGISTER_DELEGATION)}><FontAwesomeIcon icon={faPlus} className={styles.buttonIcon} />Delegation</button></Col></Row></Container></Col></Row>;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <h3 className="pb-4">Consolidations</h3>;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <Image unoptimized={true} loading="eager" priority={true} src="/consolidation-icon.png" alt="consolidation" width={50} height={50} />;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <Col sm={12} md={9} className="pt-2 pb-2 d-flex align-items-center justify-content-between gap-2"><span className="d-flex flex-column">{t12}<span className="d-flex align-items-center gap-3">{t13}<ul className="mb-0"><li>Use up to 3 wallets to manage your 6529 Collections NFTs</li><li>Transfer NFTs between wallets without losing TDH</li></ul></span></span></Col>;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <Row className="pt-2"><Col><Container className={`${styles.delegationCenterSection} pt-4 pb-4`}><Row>{t14}<Col sm={12} md={3} className="pt-2 pb-2 d-flex align-items-center justify-content-center"><button className={`${styles.addNewDelegationBtn}`} onClick={() => setRedirect(DelegationCenterSection.REGISTER_CONSOLIDATION)}><FontAwesomeIcon icon={faPlus} className={styles.buttonIcon} />Consolidation</button></Col></Row></Container></Col></Row>;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <h3 className="pb-4">Delegation Management</h3>;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <Image unoptimized={true} loading="eager" priority={true} src="/manager-icon.png" alt="delegation-manager" width={50} height={50} />;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  let t18;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <Col sm={12} md={9} className="pt-2 pb-2 d-flex align-items-center justify-content-between gap-2"><span className="d-flex flex-column">{t16}<span className="d-flex align-items-center gap-3">{t17}<ul className="mb-0"><li>Give another wallet permission to handle delegations and consolidations on your behalf</li><li>Increase your wallet security</li></ul></span></span></Col>;
    $[31] = t18;
  } else {
    t18 = $[31];
  }
  let t19;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <Row className="pt-2"><Col><Container className={`${styles.delegationCenterSection} pt-4 pb-4`}><Row>{t18}<Col sm={12} md={3} className="pt-2 pb-2 d-flex align-items-center justify-content-center"><button className={`${styles.addNewDelegationBtn}`} onClick={() => setRedirect(DelegationCenterSection.REGISTER_SUB_DELEGATION)}><FontAwesomeIcon icon={faPlus} className={styles.buttonIcon} />Delegation Manager</button></Col></Row></Container></Col></Row>;
    $[32] = t19;
  } else {
    t19 = $[32];
  }
  let t20;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <Container>{t7}{t11}{t15}{t19}<Row className="pt-4"><Col>{printCollectionSelection()}</Col></Row></Container>;
    $[33] = t20;
  } else {
    t20 = $[33];
  }
  return t20;
}